<div class="main">
  <ui-topbar></ui-topbar>
  <!-- <ui-favbar [buttons]="favbarButtons"></ui-favbar> -->
  <lib-sidebar #sidebarRef [items]="sidebarItems" (sidebarToggled)="onSidebarToggled($event)"></lib-sidebar>
  <div class="content">
    <ui-header></ui-header>
    <router-outlet></router-outlet>
  </div>
</div>